<template>
  <div class="logos" :class="{ mono, cards: !mono }">
    <div v-for="p in partners" :key="p.name" class="logo-cell" :title="p.name">
      <img :src="p.img" :alt="p.name" loading="lazy" />
    </div>
  </div>
</template>

<script>
import { partners } from '@/data/company';

export default {
  name: 'PartnerLogos',
  props: { mono: { type: Boolean, default: true } },
  data() { return { partners }; },
};
</script>

<style scoped>
.logos { display: grid; gap: 24px; align-items: center; }
.logos.mono { grid-template-columns: repeat(8, minmax(0, 1fr)); border-top: 1px solid var(--line); border-bottom: 1px solid var(--line); padding: 28px 0; }
.logos.mono img { max-height: 52px; margin: 0 auto; filter: grayscale(1); opacity: 0.6; transition: filter .2s ease, opacity .2s ease; }
.logos.mono .logo-cell:hover img { filter: none; opacity: 1; }
.logos.cards { grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 16px; }
.logos.cards .logo-cell { background: var(--card); border: 1px solid var(--line); border-radius: 12px; height: 104px; display: flex; align-items: center; justify-content: center; padding: 20px; }
.logos.cards img { max-height: 56px; }
@media (max-width: 900px) {
  .logos.mono { grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 16px 12px; padding: 20px 0; }
  .logos.mono img { max-height: 30px; }
  .logos.cards { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
</style>
